import { axiosApi } from "shared/api/axios";
import { EmployeesResponse } from "../types";

export const getEmployees = async (
    currentPage: number, 
    search_param?: string,
    order_by?: any,
    order_asc?: any,
    signal?: AbortSignal
): Promise<EmployeesResponse> => {
    try {
        const baseUrl = `${process.env.API_BACKEND}/v1/users/user/?page=${currentPage}&size=10&order_asc=${order_asc}&order_by=${order_by}`;
        const searchFilter = search_param ? `&search_param=${encodeURIComponent(search_param)}` : "";
        const url = `${baseUrl}${searchFilter}`;
        const response = await axiosApi.get<EmployeesResponse>(url, {signal});
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};